<template>
    <div class="setup-container">
        <el-form :model="formData" label-suffix=":" v-if="formItems.length">
            <template v-for="(item, index) in formItems" :key="index">
                <div class="group-container" v-if="item.children?.length">
                    <p>{{ item.name }}</p>
                    <template v-for="child in item.children" :key="child.id">
                        <el-form-item :label="child.name" label-width="200px">
                            <el-select v-if="child.options" v-model="formData[child.id]" style="width: 300px">
                                <el-option v-for="v in toArray(child.options)" :key="v.value" :label="v.label" :value="v.value" />
                            </el-select>
                            <template v-else>
                                <template v-if="child.type == 'number'">
                                    <el-input-number
                                        v-model="formData[child.id]"
                                        :precision="child.place || null"
                                        :max="child.max || Infinity"
                                        :min="child.min || -Infinity"
                                    ></el-input-number>
                                    <span v-if="child.unit" style="margin-left: 10px">({{ child.unit }})</span>
                                </template>
                                <el-input
                                    v-if="child.type === 'string'"
                                    v-model="formData[child.id]"
                                    placeholder="请输入"
                                    style="width: 300px"
                                >
                                    <template #append v-if="child.unit">{{ child.unit }}</template>
                                </el-input>
                                <el-input
                                    v-if="child.type === 'textarea'"
                                    type="textarea"
                                    v-model="formData[child.id]"
                                    placeholder="请输入"
                                    style="width: 800px"
                                    :rows="child.input_extend?.split('=')[1]"
                                >
                                    <template #append v-if="child.unit">{{ child.unit }}</template>
                                </el-input>
                            </template>
                        </el-form-item>
                    </template>
                </div>
            </template>
            <el-form-item class="submit">
                <el-button type="primary" style="margin-left: 200px" @click="submit">提交</el-button>
            </el-form-item>
        </el-form>
        <el-empty v-else image="@assets/images/noData.png" :image-size="400"></el-empty>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { batchConfigSetting, getConfigSettingOptionLists } from '@/api/configModuleitem'
import { ElMessage, ElMessageBox } from 'element-plus'

const route = useRoute()
const store = useStore()
const formData = ref({})
const formItems = ref([])

// 配置项
const getConfigItemOptionListFn = async (module = store.getters.subsystem) => {
    console.log(store.getters.subsystem)
    const data = await getConfigSettingOptionLists({
        module: module
    })
    if (data.length > 0) {
        // console.log(data)
        formItems.value = data
        data.forEach((ele) => {
            ele.children &&
                ele.children.forEach((child) => {
                    if (!child.options && (child.data_type === 'int' || child.data_type === 'float')) {
                        formData.value[child.id] = child.value ? Number(child.value) : 0
                    } else {
                        formData.value[child.id] = child.value
                    }
                })
        })
    } else {
        formData.value = {}
        formItems.value = []
    }
}
// options转数组
const toArray = (data) => {
    const list = []
    for (const key in data) {
        list.push({
            value: key,
            label: data[key]
        })
    }
    return list
}
// 提交
const submit = async () => {
    ElMessageBox.confirm('是否确认要修改配置项!', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const params = { ...formData.value }
            for (const key in params) {
                params[key] = params[key].toString()
            }
            await batchConfigSetting(params)
            ElMessage.success('操作成功')
        })
        .catch(() => {})
}

onMounted(async () => {
    await getConfigItemOptionListFn(route.query.module)
})
</script>
<style scoped lang="scss">
.el-empty {
    margin: 0 auto;
}

:deep(.el-form-item) {
    margin-bottom: 0;
    border-bottom: 1px solid #ebf0fc;
    padding: 15px 0px;
}

:deep(.el-form-item.submit) {
    border-bottom: none;
    padding: 20px 0;
    background-color: #f1f5fd;
}

.module-box {
    width: 150px;
    background-color: #fafcfe;
    box-sizing: border-box;
    font-size: 14px;
    border-right: 1px solid #d9d9e1;
    height: calc(100vh - 113px);
    border-bottom-left-radius: 15px;

    h4 {
        padding: 10px 20px;
        line-height: 28px;
        font-weight: normal;
        color: #7c7e82;
        // border-bottom: 1px solid #ddd;
        font-size: 14px;
        display: flex;
        align-items: center;
    }

    li {
        padding: 12px 20px;
        cursor: pointer;
        position: relative;
        color: #232323;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:hover {
            background-color: var(--el-color-primary-light-9);
        }
    }

    .active {
        background-color: var(--el-color-primary-light-9);

        // border-right: 2px solid #4291F7;
        &::after {
            position: absolute;
            right: -1px;
            top: 0;
            content: '';
            width: 2px;
            height: 100%;
            background-color: #4291f7;
        }
    }
}

.setup-container {
    width: 100%;
    overflow-y: auto;
    display: flex;
    margin-top: -10px;
}

.el-form {
    box-sizing: border-box;
    margin-bottom: 10px;
    height: calc(100vh - 113px);
    overflow-y: auto;
    flex: 1;
    padding: 20px 0 20px 20px;
    // width: 50%;
    // margin: 0 auto;
}

.group-container {
    // border: 1px solid #cbc9c9;
    border-radius: 20px;
    // padding: 20px;
    box-sizing: border-box;
    position: relative;

    p {
        font-weight: 700;
        background-color: #f1f5fd;
        padding: 10px 20px;
        border-left: 2px solid #63a4f7;
    }
}
</style>
